/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'close-small': {
    width: 16,
    height: 16,
    viewBox: '0 0 8 8',
    data: '<g _fill="none" fill-rule="evenodd"><g _fill="#FFF"><path pid="0" d="M4.146 3.293l2.122-2.121a.75.75 0 1 1 1.06 1.06l-2.12 2.122 2.12 2.12a.75.75 0 0 1-1.06 1.062L4.146 5.414l-2.12 2.122A.75.75 0 0 1 .963 6.475l2.122-2.121L.964 2.232a.75.75 0 0 1 1.061-1.06l2.121 2.12z"/></g></g>'
  }
})
